/**
 * Safe wrappers for localStorage operations.
 *
 * localStorage can throw a DOMException in private / restricted browser
 * contexts (iOS Safari private mode, strict iframe sandbox policies, etc.).
 * Wrapping every access in try-catch prevents uncaught exceptions from
 * propagating into React's render phase and triggering the ErrorBoundary.
 */

export function safeGetItem(key: string): string | null {
  try { return localStorage.getItem(key); } catch { return null; }
}

export function safeSetItem(key: string, value: string): void {
  try { localStorage.setItem(key, value); } catch { /* storage unavailable */ }
}

export function safeRemoveItem(key: string): void {
  try { localStorage.removeItem(key); } catch { /* storage unavailable */ }
}
